import "./App.css";

// =====================================================
// OWNER SETTINGS
// =====================================================

const OWNER_SETTINGS = {
  youtubeChannel: "https://www.youtube.com/@Infiflowtelugu/videos",
  blenderPlaylist: "https://www.youtube.com/@infiflowtelugu",
};

// =====================================================
// PDF RESOURCES
// Add your PDF files inside: public/pdfs/
// =====================================================

const pdfResources = [
  {
    title: "Blender Beginner Notes",
    description: "Blender basics and beginner concepts.",
    file: "/pdfs/blender-beginner-notes.pdf",
  },
  {
    title: "Blender Shortcuts",
    description: "Useful Blender keyboard shortcuts.",
    file: "/pdfs/blender-shortcuts.pdf",
  },
];

// =====================================================
// APP
// =====================================================

function App() {
  return (
    <div className="app">
      {/* =================================================
          NAVBAR
      ================================================= */}

      <nav className="navbar">
        <div className="logo">Infiflow Telugu</div>

        <ul>
          <li>
            <a href="#home">Home</a>
          </li>
          <li>
            <a href="#about">About</a>
          </li>
          <li>
            <a href="#learn">Learn</a>
          </li>
          <li>
            <a href="#fundamentals">Fundamentals</a>
          </li>
          <li>
            <a href="#resources">Resources</a>
          </li>
          <li>
            <a href="#services">Services</a>
          </li>
          <li>
            <a href="#contact">Contact</a>
          </li>
        </ul>
      </nav>

      {/* =================================================
          HERO
      ================================================= */}

      <section className="hero" id="home">
        <div className="hero-text">
          <span className="badge">🚀 Learn Blender in Telugu</span>

          <h1>
            Learn Blender &
            <br />
            3D Animation
            <br />
            in Telugu
          </h1>

          <p>
            Master Blender, 3D Modeling, Materials, Animation, Rendering, Motion
            Graphics, AI Workflows and Video Editing with beginner-friendly
            Telugu tutorials.
          </p>

          <div className="hero-btns">
            <a
              href={OWNER_SETTINGS.youtubeChannel}
              target="_blank"
              rel="noopener noreferrer"
              className="btn"
            >
              Watch Tutorials
            </a>

            <a href="#contact" className="btn2">
              Contact Me
            </a>
          </div>
        </div>

        <div className="hero-image">
          <div className="image-box">
            <img
              src="https://res.cloudinary.com/db4faz2rs/image/upload/v1788671054/final_logo_x8cw4n.png"
              alt="Blender 3D"
            />
          </div>
        </div>
      </section>

      {/* =================================================
          ABOUT
      ================================================= */}

      <section className="about" id="about">
        <span className="section-tag">ABOUT US</span>

        <h2>About Infiflow Telugu</h2>

        <p>
          Infiflow Telugu is a learning platform dedicated to helping Telugu
          creators master Blender, 3D Animation, Video Editing and AI Tools.
        </p>

        <p>
          Whether you're a beginner or an experienced designer, our tutorials
          simplify complex workflows into easy step-by-step lessons.
        </p>
      </section>

      {/* =================================================
          BLENDER FUNDAMENTALS
      ================================================= */}

      <section className="fundamentals" id="fundamentals">
        <div className="fundamental-glow glow-left"></div>

        <div className="fundamental-glow glow-right"></div>

        <div className="fundamentals-container">
          {/* HEADER */}

          <div className="fundamentals-header">
            <div className="fundamental-badge">
              <span className="badge-icon">✦</span>
              Complete Learning Path
            </div>

            <h2>
              Beginner to Pro
              <br />
              <span>Blender Fundamentals</span>
            </h2>

            <p>
              Blender ni complete beginner level nunchi professional level
              varaku step-by-step ga nerchukondi. Modeling, Materials,
              Animation, Lighting, Rendering and more.
            </p>
          </div>

          {/* ROADMAP */}

          <div className="blender-roadmap">
            <div className="roadmap-progress"></div>

            {/* BEGINNER */}

            <div className="blender-step">
              <div className="step-top">
                <span className="step-number">01</span>

                <div className="css-icon">
                  <span className="icon-cursor"></span>
                </div>
              </div>

              <span className="step-label">LEVEL 01</span>

              <h3>Beginner</h3>

              <p>Interface, Navigation & Basic Tools</p>
            </div>

            {/* INTERMEDIATE */}

            <div className="blender-step">
              <div className="step-top">
                <span className="step-number">02</span>

                <div className="css-icon">
                  <span className="icon-cube"></span>
                </div>
              </div>

              <span className="step-label">LEVEL 02</span>

              <h3>Intermediate</h3>

              <p>Modeling, Materials & Texturing</p>
            </div>

            {/* ADVANCED */}

            <div className="blender-step">
              <div className="step-top">
                <span className="step-number">03</span>

                <div className="css-icon">
                  <span className="icon-play"></span>
                </div>
              </div>

              <span className="step-label">LEVEL 03</span>

              <h3>Advanced</h3>

              <p>Animation, Lighting & Rendering</p>
            </div>

            {/* PRO */}

            <div className="blender-step">
              <div className="step-top">
                <span className="step-number">04</span>

                <div className="css-icon">
                  <span className="icon-star">★</span>
                </div>
              </div>

              <span className="step-label">LEVEL 04</span>

              <h3>Pro</h3>

              <p>Professional 3D & Production Workflows</p>
            </div>
          </div>

          {/* SKILLS */}

          <div className="fundamental-skills">
            <div className="skill-pill">
              <span>◆</span>
              3D Modeling
            </div>

            <div className="skill-pill">
              <span>✦</span>
              Materials
            </div>

            <div className="skill-pill">
              <span>◉</span>
              Lighting
            </div>

            <div className="skill-pill">
              <span>▶</span>
              Animation
            </div>

            <div className="skill-pill">
              <span>◇</span>
              Rendering
            </div>
          </div>

          {/* CTA */}

          <div className="fundamentals-cta">
            <div className="cta-content">
              <div className="cta-check">✓</div>

              <div>
                <h4>Complete Blender Learning Path</h4>

                <p>Start from zero and build professional Blender skills.</p>
              </div>
            </div>

            <a
              href={OWNER_SETTINGS.blenderPlaylist}
              target="_blank"
              rel="noopener noreferrer"
              className="fundamentals-button"
            >
              <span className="button-play">▶</span>
              Start Learning
              <span className="button-arrow">→</span>
            </a>
          </div>
        </div>
      </section>

      {/* =================================================
          WHAT YOU'LL LEARN
      ================================================= */}

      <section className="learn" id="learn">
        <span className="section-tag">LEARNING</span>

        <h2>What You'll Learn</h2>

        <div className="cards">
          <div className="card">
            <div className="card-icon">◆</div>
            <h3>Blender</h3>
            <p>Modeling, Materials, Texturing, UV Mapping & Geometry Nodes.</p>
          </div>

          <div className="card">
            <div className="card-icon">▶</div>
            <h3>Animation</h3>
            <p>Camera Animation, Logo Animation & Product Animation.</p>
          </div>

          <div className="card">
            <div className="card-icon">◉</div>
            <h3>Rendering</h3>
            <p>Cycles, Eevee, HDRI Lighting & Realistic Materials.</p>
          </div>

          <div className="card">
            <div className="card-icon">✦</div>
            <h3>Video Editing</h3>
            <p>Premiere Pro, After Effects & Motion Graphics.</p>
          </div>

          <div className="card">
            <div className="card-icon">◇</div>
            <h3>AI Tools</h3>
            <p>AI Images, AI Video Generation & Workflow Automation.</p>
          </div>

          <div className="card">
            <div className="card-icon">★</div>
            <h3>Freelancing</h3>
            <p>Portfolio Building, Client Projects & Career Guidance.</p>
          </div>
        </div>
      </section>

      {/* =================================================
          PDF RESOURCES
      ================================================= */}

      <section className="resources" id="resources">
        <div className="resources-header">
          <span className="section-tag">FREE RESOURCES</span>

          <h2>PDF Resources</h2>

          <p>Useful Blender notes, shortcuts and learning materials.</p>
        </div>

        <div className="pdf-grid">
          {pdfResources.map((pdf, index) => (
            <div className="pdf-card" key={index}>
              <div className="pdf-icon">PDF</div>

              <div className="pdf-info">
                <h3>{pdf.title}</h3>

                <p>{pdf.description}</p>

                <a
                  href={pdf.file}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pdf-button"
                >
                  View PDF →
                </a>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* =================================================
          SERVICES
      ================================================= */}

      <section className="services" id="services">
        <span className="section-tag">SERVICES</span>

        <h2>Our Services</h2>

        <div className="cards">
          <div className="card">
            <div className="card-icon">◆</div>
            <h3>3D Product Visualization</h3>
            <p>Create premium quality product renders.</p>
          </div>

          <div className="card">
            <div className="card-icon">◇</div>
            <h3>Architectural Visualization</h3>
            <p>Interior & Exterior 3D Designs.</p>
          </div>

          <div className="card">
            <div className="card-icon">▶</div>
            <h3>Motion Graphics</h3>
            <p>Professional Motion Design & Animations.</p>
          </div>

          <div className="card">
            <div className="card-icon">✦</div>
            <h3>Video Editing</h3>
            <p>High Quality Editing for YouTube & Social Media.</p>
          </div>

          <div className="card">
            <div className="card-icon">★</div>
            <h3>YouTube Consultation</h3>
            <p>Channel Growth & Content Strategy.</p>
          </div>

          <div className="card">
            <div className="card-icon">∞</div>
            <h3>AI Workflow</h3>
            <p>Boost Creativity with AI Tools.</p>
          </div>
        </div>
      </section>

      {/* =================================================
          CONTACT
      ================================================= */}

      <section className="contact" id="contact">
        <span className="section-tag">CONTACT</span>

        <h2>Get In Touch</h2>

        <p>Have questions? Feel free to contact us.</p>

        <div className="contact-box">
          <input type="text" placeholder="Your Name" />

          <input type="email" placeholder="Your Email" />

          <textarea rows="5" placeholder="Your Message"></textarea>

          <button className="btn">Send Message</button>
        </div>
      </section>

      {/* =================================================
          FOOTER
      ================================================= */}

      <footer>
        <h3>Infiflow Telugu</h3>

        <p>Learn Blender, Animation, Video Editing & AI in Telugu.</p>

        <div className="footer-links">
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#learn">Learn</a>
          <a href="#fundamentals">Fundamentals</a>
          <a href="#resources">Resources</a>
          <a href="#services">Services</a>
          <a href="#contact">Contact</a>
        </div>

        <small>© 2026 Infiflow Telugu. All Rights Reserved.</small>
      </footer>
    </div>
  );
}

export default App;
